import * as React from 'react';
import styled from 'styled-components';
import { my } from '@lendi-ui/spacing';
import Spinner from '@lendi-ui/spinner';

const Wrapper = styled.div`
  font-size: 3rem;
  text-align: center;
  ${my('sm')}
`;

export const InfiniteScrollSpinner = () => (
  <Wrapper>
    <Spinner />
  </Wrapper>
);
